import { ProductType } from "@b2bportal/core-types";
import type { Traveler } from "@b2bportal/traveler-api";
import type { TFunction } from "i18next";

export const getTravellerFormTitle = (
  currentTraveler: Traveler,
  travelerList: Traveler[],
  t: TFunction
) => {
  if (currentTraveler) {
    return t("checkout.travelerInformation.travelerForm.editTraveler");
  } else if (travelerList.length > 0) {
    return t("checkout.travelerInformation.travelerForm.title");
  }
  return t("checkout.travelerInformation.travelerForm.primaryTraveler");
};

export const getTravellerFormSubtitle = (
  productType: ProductType,
  t: TFunction
) => {
  switch (productType) {
    case ProductType.CARS:
      return t("checkout.travelerInformation.travelerForm.subtitleCars");
    case ProductType.FLIGHTS:
      return t("checkout.travelerInformation.travelerForm.subtitle");
  }
  return t("checkout.travelerInformation.travelerForm.subtitle");
};
